module.exports = __webpack_public_path__ + "img/3.fe35a941.png";